import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'

/**
 * ログインAPI
 * @param  {} params={}
 */
export const login = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  // @/util/axios_no_error を使用する。
  // 通常ログインは、Login.js内でのエラー処理を実施するため、共通エラー処理をしない。
  // フロントエンドログインはエラーを出さない。
  const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
  return newAxiosNoError.post('/LG/001', r).then(response => {
    return response
  }).catch(error => {
    console.error('[Login] API Error:', error)
    throw error
  })
}

/**
 * ログイントークンリセットAPI
 * @param  {} params={}
 */
export const resetToken = (params = {}) => {
  const token = process.env.NODE_ENV === 'development'
    ? DEV_API_TOKEN
    : store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    login_id: params.login_id || '',
    password: params.password || '',
    organization_id: organizationId
  }

  // @/util/axios_no_error を使用する。
  // Login.js内でのエラー処理を実施するため、共通エラー処理をしない。
  const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
  return newAxiosNoError.post('/LG/002', r)
}
